export default {
    title: "Page not found",
    description: "Sorry, but the page you requested was not found or does not exist.<br/>Try our search.",
    button: "Home Page",
};
